import { publicEnv } from '~/features/environment/public';
import { Currency } from '~/features/internationalization/models/currency';
import { logger } from '~/features/logging/logger';

import { BraavosPlanPrices, braavosPlanPricesSchema } from '../models/braavos-plan-prices';

const PATH_TO_MODULE = 'src/features/plans/controllers/get-price-plans.ts';
const FUNCTION_NAME = 'getPricePlans';

export async function getPricePlans({
  currency,
  coupon,
  userId,
  anonymousId,
}: {
  currency: Currency;
  userId?: string;
  anonymousId?: string;
  coupon?: string | null;
}): Promise<BraavosPlanPrices> {
  const url = new URL(`${publicEnv.NEXT_PUBLIC_BRAAVOS_URL}/plan_prices`);

  url.searchParams.set('currency', currency);
  if (anonymousId) {
    url.searchParams.set('anonymous_id', anonymousId);
  }
  if (userId) {
    url.searchParams.set('user_id', userId);
  }
  if (coupon) {
    url.searchParams.set('coupon', coupon);
  }
  const response = await fetch(url.toString(), {
    headers: {
      'Content-Type': 'application/json',
    },
  });

  const data = await response.json().catch(() => {});
  if (!response.ok) {
    logger.fatal('Error fetching price plans', {
      file: PATH_TO_MODULE,
      function: FUNCTION_NAME,
      statusCode: response.status,
      error: data,
    });

    throw new Error(`Error fetching price plans: ${JSON.stringify(data)}`);
  }

  try {
    return braavosPlanPricesSchema.parse(data);
  } catch (error) {
    logger.fatal('Error parsing price plans', {
      file: PATH_TO_MODULE,
      function: FUNCTION_NAME,
      error: error,
    });

    // Rethrow so that the error is caught by react-query
    throw error;
  }
}
